var map = {
  "terms-landing": function match(pathname) {
    return pathname.includes("terms");
  },
  "privacy-policy": function match(pathname) {
    return pathname.includes("privacy");
  },
  "return-policy": function match(pathname) {
    return pathname.includes("return");
  }
};
export var extractStaticPageSlug = function extractStaticPageSlug(pathname) {
  var slug;
  // use map above to find the correct slug, which is the key in the map,
  for (var key in map) {
    if (map[key](pathname)) {
      slug = key;
      break;
    }
  }
  if (!slug) {
    return null;
  }
  return slug;
};
export default extractStaticPageSlug;